var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "fill",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4208 11.0872C21.4208 10.9497 21.3083 10.8372 21.1708 10.8372L19.1083 10.8465L16.002 14.5497L12.8989 10.8497L10.8333 10.8403C10.6958 10.8403 10.5833 10.9497 10.5833 11.0903C10.5833 11.1497 10.6051 11.2059 10.6426 11.2528L14.7083 16.0965L10.6426 20.9372C10.6049 20.983 10.5839 21.0403 10.5833 21.0997C10.5833 21.2372 10.6958 21.3497 10.8333 21.3497L12.8989 21.3403L16.002 17.6372L19.1051 21.3372L21.1676 21.3465C21.3051 21.3465 21.4176 21.2372 21.4176 21.0965C21.4176 21.0372 21.3958 20.9809 21.3583 20.934L17.2989 16.0934L21.3645 11.2497C21.402 11.2059 21.4208 11.1465 21.4208 11.0872Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 2.03125C8.26875 2.03125 2 8.3 2 16.0312C2 23.7625 8.26875 30.0312 16 30.0312C23.7313 30.0312 30 23.7625 30 16.0312C30 8.3 23.7313 2.03125 16 2.03125ZM16 27.6562C9.58125 27.6562 4.375 22.45 4.375 16.0312C4.375 9.6125 9.58125 4.40625 16 4.40625C22.4188 4.40625 27.625 9.6125 27.625 16.0312C27.625 22.45 22.4188 27.6562 16 27.6562Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleClose);
export default __webpack_public_path__ + "static/media/circle-close.ebcc41adc5f9fe5c451ee951c43486b0.svg";
export { ForwardRef as ReactComponent };